// extracted by mini-css-extract-plugin
export default {"wrapper-background":"TapForNextRound_wrapper-background__9q9O4","items":"TapForNextRound_items__suyx1"};